import { OrderItem } from '@/types/fnb'

import { requestWithRetry } from '../axios'

export interface OrderConfirmedData {
  order_id: string
  location_name: string
  collection_time: string
  items: OrderItem[]
}

export type OrderConfirmedResult =
  | { status: 'complete'; data: OrderConfirmedData }
  // Backend returns 400 "Order is not complete." while the Stripe webhook +
  // POS submission that set `external_id` are still in flight. Not an error —
  // the caller should keep polling.
  | { status: 'pending' }
  // Payment genuinely failed / refunded (backend 500 "Payment process ... has
  // failed."), or any other unexpected response. The caller should stop
  // polling and surface an honest failure.
  | { status: 'failed' }

const PENDING_DETAIL = 'Order is not complete.'

export const getOrderConfirmed = async (
  fnb_uid: string,
): Promise<OrderConfirmedResult> => {
  try {
    const data = await requestWithRetry(`fnb/order/${fnb_uid}/confirmed`, 'get')
    return { status: 'complete', data }
  } catch (error: any) {
    const status = error?.response?.status
    const detail = error?.response?.data?.detail

    if (status === 400 && detail === PENDING_DETAIL) {
      return { status: 'pending' }
    }

    console.error('getOrderConfirmed error:', error?.response?.data ?? error)
    return { status: 'failed' }
  }
}
